import JobAlert from "@spa/features/search_job/pc/components/list/JobAlert";
import {PaginationForNoResult} from "@spa/features/search_job/pc/components/list/Pagination";

/**
 * 検索結果が0件の時の表示
 * @constructor
 */
export const SearchJobNoResult = ({translations, isDisplayJobAlert}) => {
    const translationsNoResult = translations.no_result;
    return (
        <main className="s-main">
            <div className="l-c-result l-c-result--search l-c-result--error">
                <div className="l-c-left">
                    <div className="p-result_wrap u-mt40">
                        <h2 className="u-fs20">{translationsNoResult.no_jobs}</h2>
                        <p className="u-mt20">{translationsNoResult.for_better_results}</p>
                        <ul className="u-mt10">
                            <li className="c-list--dot">{translationsNoResult.make_sure_keywords}</li>
                            <li className="c-list--dot">{translationsNoResult.use_full_words}</li>
                            <li className="c-list--dot">{translationsNoResult.remove_filters}</li>
                        </ul>
                    </div>
                    {isDisplayJobAlert && <JobAlert translations={translations} />}
                </div>
            </div>
        </main>
    );
}

/**
 * ページングの結果0件になった時の表示
 * @param searchResultViewModel
 * @constructor
 */
export const SearchJobNoResultPaging = ({searchResultViewModel}) => {
    const translationsNoResult = searchResultViewModel.translations.no_result;

    return (
        <main className="s-main">
            <div className="l-c-result l-c-result--search l-c-result--error">
                <div className="l-c-left">
                    <p className="p-result_num">{searchResultViewModel.hitCountDisplay}</p>
                    <div className="p-result_wrap u-mt40">
                        <h2 className="u-fs20">{translationsNoResult.sorry_we_dont_serve}</h2>
                        <p className="u-mt20">{translationsNoResult.search_suggestions}</p>
                        <ul className="u-mt10">
                            <li className="c-list--dot">{translationsNoResult.try_different_keywords}</li>
                            <li className="c-list--dot">{translationsNoResult.try_changing_filters}</li>
                        </ul>
                        <PaginationForNoResult
                            previousPageUrl={searchResultViewModel.previousPageUrl}
                            firstPageUrl={searchResultViewModel.currentUrlWithoutParameters}
                            pageCountDisplay={searchResultViewModel.pageCountDisplay}
                            translations={searchResultViewModel.translations.pagination}
                        />
                    </div>
                    {searchResultViewModel.isDisplayJobAlert && <JobAlert translations={searchResultViewModel.translations} />}
                </div>
            </div>
        </main>
    );
}
